import { Injectable } from '@angular/core';
import { Observable,Subject, from } from 'rxjs';
import { GlobalVariable } from 'app/global/global';
import { HttpClient,HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class GeneralService {


  //
  url:string = GlobalVariable.BASE_API_URL+"api/general/";
  private estudioMedicoSubject = new Subject<any>();


  //
  constructor(private http:HttpClient) { }


  //
  mostrar():Observable<any>{
    
    return this.http.get(this.url+"mostrar");
  }


  //
  guardar(val:any):Observable<any>{
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    const formData = new FormData(); 
    formData.append("turnosPaciente",val.turnosPaciente);
    formData.append("rangoHasta",val.rangoHasta);
    formData.append("tiempoEdicionEstudiosMedicos", val.tiempoEdicionEstudiosMedicos);
    formData.append("horas_cancelacion_falta_pago", val.horas_cancelacion_falta_pago);
    formData.append("mp_pago_activo", val.mp_pago_activo);
    formData.append("mp_split_activo", val.mp_split_activo);
    formData.append("landingColor", val.landingColor);
    return this.http.post(this.url+"guardar",formData,{headers:headers});
  }

  
}
